module.exports = __webpack_public_path__ + "img/asteroid.9779ab72.png";